import './MessageView.css';

import { IonCard, IonCardContent, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, useIonToast } from '@ionic/react';
import { addOutline, attachOutline, sendOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from 'react';
import { RouteComponentProps } from 'react-router';

import ActionButton from '../../../../components/button/ActionButton';
import InputItem from '../../../../components/input/InputItem';
import LoadingContainer from '../../../../components/loading/LoadingContainer';
import Container from '../../../../layouts/Container';
import LayoutGap from '../../../../layouts/LayoutGap';
import Toolbar from '../../../../layouts/Toolbar';
import { DataProvider } from '../../../../library/DataProvider';
import { MessageViewGetAction, SubmitMessagePostAction, UploadAttachPostAction } from '../../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { isWebView, passToWebView } from '../../../../library/Funcs';

interface Props extends RouteComponentProps<{
    message_id: string
}> { }

const MessageView: React.FC<Props> = ({ match }) => {
    const [toast, dismiss] = useIonToast();
    const attachFileRef = useRef<HTMLInputElement>(null);

    const dispatch = useAppDispatch()

    const { form_loading2, resp2 } = useAppSelector(state => state.uploadAttach)

    const { form_loading, resp } = useAppSelector(state => state.submitMessageReducer)
    const { loading, message } = useAppSelector(state => state.messageViewReducer)

    const [singleMessage, setSingleMessage] = useState(null as any);

    const [form, setForm] = useState({
        message: { value: "", validation: { required: true }, error: "" },
        attach: { value: "", validation: {}, error: "" }
    });

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    useEffect(() => {
        dispatch(MessageViewGetAction(match.params.message_id))
    }, [])

    useEffect(() => {
        if (message != null && !loading) {
            setSingleMessage(message);
        }
    }, [loading])

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        if (formValidation) {
            dispatch(SubmitMessagePostAction(match.params.message_id, "", form.message.value, form.attach.value))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    toast({ message: resp.message, duration: 2000, color: "primary" })

                    setSingleMessage(resp.ticket);

                    const f = { ...form }
                    f.attach.value = "";
                    setForm(f);

                    formProvider.reset();
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])


    // Attach
    const attachFileSelectHandler = async () => {
        if (isWebView()) {
            await passToWebView("requestCameraPermission", "");
        }

        attachFileRef.current?.click();
    }

    const attachChangeHandler = (e: any) => {
        let file = e.target.files[0];

        dispatch(UploadAttachPostAction(file));
    }

    useEffect(() => {
        const uploadDone = () => {
            if (resp2 != null && !form_loading2) {
                if (resp2.result) {
                    const f = { ...form }
                    f.attach.value = resp2.file;
                    setForm(f);
                } else {
                    toast({ message: resp2.message, duration: 2000, color: "danger" })
                }
            }
        }

        uploadDone();
    }, [form_loading2])

    return <LoadingContainer loading={loading}>
        <IonPage className="message-view">
            <Toolbar title={singleMessage?.subject} subTitle={singleMessage?.status_title} hasBackButton />

            <LayoutGap />

            <IonContent className="main-content">
                <Container className="messages" overflowY scrollBottom scrollCondition={singleMessage}>
                    {singleMessage?.messages?.map((item: any) => {
                        return <div key={`message-view-${item.id}`} className={item.writer == 'REPLIER' ? 'message-item admin' : 'message-item user'}>
                            <img src={item.avatar} />
                            <div className="message">
                                <IonCard className="text">
                                    <IonCardContent>
                                        <IonText><div dangerouslySetInnerHTML={{ __html: item.message }}></div></IonText>
                                    </IonCardContent>
                                </IonCard>

                                <IonText className="date">{item.date}</IonText>

                                {item.attach.length > 0 ? <a href={item.attach} target="blank" className="attach-link"><IonIcon icon={attachOutline} /></a> : null}
                            </div>
                        </div>;
                    })}
                </Container>

                <div className="add-message">
                    <form onSubmit={formSubmitHandler}>
                        <IonRow>
                            <IonCol size="10" className="ion-no-padding">
                                <ActionButton loading={form_loading2} class="attach-button" click={attachFileSelectHandler} noSubmit hasBadge={form.attach.value.length > 0} color="blue">
                                    <IonIcon icon={addOutline} />
                                </ActionButton>

                                <InputItem name="message" type="textarea" placeholder="پیام خود را وارد کنید ..." provider={formProvider} rows={3} simple />
                            </IonCol>
                            <IonCol size="2">
                                <ActionButton loading={form_loading} compact>
                                    <IonIcon icon={sendOutline} flipRtl />
                                </ActionButton>

                                <div className="upload-container">
                                    <input type="file" accept=".jpg, .jpeg, .png" ref={attachFileRef} onClick={(e: any) => e.target.value = null} onChange={attachChangeHandler} />
                                </div>
                            </IonCol>
                        </IonRow>
                    </form>
                </div>
            </IonContent>
        </IonPage>
    </LoadingContainer>
}

export default MessageView